module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/day02_10_stay-adbeb92b1bbe265bf08d4b7a0af8e385.jpg";